// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_cLa","cls2":"CollapsedActivityPreview-cls2_WO8 CollapsedActivityPreview-cls1_cLa"};